import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceOnlyPageService } from '../services/serviceOnlyPageService';
import { message } from 'antd';
import { ServiceOnlyPage } from '../types/serviceOnlyPage';

export const useServiceOnlyPages = (tenantId: string, status?: string) => {
  return useQuery({
    queryKey: ['service-only-pages', tenantId, status],
    queryFn: () => serviceOnlyPageService.list(tenantId, status),
    enabled: !!tenantId,
  });
};

export const useServiceOnlyPage = (id: string) => {
  return useQuery({
    queryKey: ['service-only-page', id],
    queryFn: () => serviceOnlyPageService.get(id),
    enabled: !!id,
  });
};

export const useGenerateServiceOnlyPageWithCrew = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: serviceOnlyPageService.generateWithCrew,
        onSuccess: () => {
            message.success('Service page generated');
            queryClient.invalidateQueries({ queryKey: ['service-only-pages'] }); 
        },
        onError: () => {
            message.error('Failed to generate service page');
        }
    })
}

export const useUpdateServiceOnlyPage = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({id, data}: {id: string, data: Partial<ServiceOnlyPage>}) => serviceOnlyPageService.update(id, data),
        onSuccess: (_, vars) => {
             message.success('Page updated');
             queryClient.invalidateQueries({ queryKey: ['service-only-pages'] });
             queryClient.invalidateQueries({ queryKey: ['service-only-page', vars.id] });
        }
    })
}

export const useDeleteServiceOnlyPage = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => serviceOnlyPageService.delete(id),
        onSuccess: () => {
             message.success('Page deleted');
             queryClient.invalidateQueries({ queryKey: ['service-only-pages'] });
        }
    })
}

export const usePublishServiceOnlyPage = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => serviceOnlyPageService.publish(id),
        onSuccess: (_, id) => {
             message.success('Page published');
             queryClient.invalidateQueries({ queryKey: ['service-only-pages'] });
             queryClient.invalidateQueries({ queryKey: ['service-only-page', id] });
        }
    })
}
